import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../ampli';
import EventImage01 from '../../../assets/images/event202405/event_01.jpg';
import EventImage02 from '../../../assets/images/event202405/event_02.jpg';
import EventImage03 from '../../../assets/images/event202405/event_03.jpg';
import EventGif01 from '../../../assets/images/event202405/event_gif_01.gif';
import { MainHead } from '../../../components/common/head/MainHead';
import { YoutubeSection } from '../../../components/common/video/YoutubeSection';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useLayout } from '../../../hooks/screen/useLayout';
import { postMessageToRN } from '../../../utils/RNCommunicator/postMessageToRN.util';

export const EventPage202405 = () => {
  const location = useLocation();

  const handlePromotionInquiryButton = () => {
    ampli.pvmClickEvent240509InquiryButton();
    ReactGA.event('pvm_click_event_240509_inquiry_button', {
      category: 'event',
      action: 'pvm_click_event_240509_inquiry_button',
    });
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'link', messageParam: 'tel:0316074997' });
    } else {
      window.location.href = 'tel:0316074997';
    }
  };

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true, directlyPassedURL: pageInfo.infoListPage.path }} />,
    fixedFooter: (
      <ButtonContainer>
        <BlurredSection />

        <BottomButton onClick={handlePromotionInquiryButton}>
          <BottomButtonText>{'문의 하기 031-607-4997'}</BottomButtonText>
        </BottomButton>
      </ButtonContainer>
    ),
    fixedHeaderHeight: 48,
    style: {
      background: '#F0f0f0',
    },
  });

  return (
    <>
      <Helmet>
        <title>{'스마트한 연합 기획전 - Pluva Market'}</title>
      </Helmet>

      <Container>
        <Image1 src={EventImage01} />

        <VideoWrapper>
          <YoutubeSection youtubeUrl={'https://www.youtube.com/watch?v=GOLihGW6BLY'} />
        </VideoWrapper>

        <Image2 src={EventImage02} />

        <VideoWrapper>
          <ReviewGif src={EventGif01} />
        </VideoWrapper>

        <Image3 src={EventImage03} />

        <VideoWrapper>
          <YoutubeSection youtubeUrl={'https://www.youtube.com/watch?v=L8_uXqqedB4'} />
        </VideoWrapper>
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  padding-bottom: 32px;
  background-color: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 100%;
`;

const Image1 = styled(Image)``;

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const ReviewGif = styled.img`
  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const Image2 = styled(Image)``;
const Image3 = styled(Image)``;

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 512px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 0px 16px;
  padding-bottom: 32px;

  gap: 8px;

  background-color: white;

  position: relative;
`;

const BlurredSection = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: var(--radius-large, 16px);
  gap: var(--radius-small, 4px);

  border-radius: var(--radius-none, 0px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 63.96%);

  position: absolute;
  top: -40px;
`;

const BottomButton = styled.button`
  width: 100%;
  height: 40px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-blue, #196eff);
`;

const BottomButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
